export const GET_ADMINS_LIST = "GET_ADMINS_LIST";
export const GET_ADMINS_LIST_SUCCESS = "GET_ADMINS_LIST_SUCCESS";
export const GET_ADMINS_LIST_FAIL = "GET_ADMINS_LIST_FAIL";

export const GET_ADMINS_SWITCHABLE_ACCS = "GET_ADMINS_SWITCHABLE_ACCS";
export const GET_ADMINS_SWITCHABLE_ACCS_SUCCESS = "GET_ADMINS_SWITCHABLE_ACCS_SUCCESS";
export const GET_ADMINS_SWITCHABLE_ACCS_FAIL = "GET_ADMINS_SWITCHABLE_ACCS_FAIL";

export const SWITCH_ADMIN_ACCOUNT = "SWITCH_ADMIN_ACCOUNT";
export const SWITCH_ADMIN_ACCOUNT_SUCCESS = "SWITCH_ADMIN_ACCOUNT_SUCCESS";
export const SWITCH_ADMIN_ACCOUNT_FAIL = "SWITCH_ADMIN_ACCOUNT_FAIL";

export const REMOVE_SWITCH_ADMIN_ACCOUNT = "REMOVE_SWITCH_ADMIN_ACCOUNT";
export const REMOVE_SWITCH_ADMIN_ACCOUNT_SUCCESS = "REMOVE_SWITCH_ADMIN_ACCOUNT_SUCCESS";
export const REMOVE_SWITCH_ADMIN_ACCOUNT_FAIL = "REMOVE_SWITCH_ADMIN_ACCOUNT_FAIL";
